import { call, put, takeLatest } from "redux-saga/effects";
import { authApi } from "../../../api/auth/authApi";
import { NotifyHelper } from "../../../helpers/toast";
import { ILoginRequest } from "../../../model/request/auth/ILoginRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { eAuthActionTypeIds, IAuthActions } from "../../action-types/auth/IAuthActions";
import { rootActions } from "../../actions/rootActions";

export function* authSaga(): any {
    yield takeLatest(eAuthActionTypeIds.LOGIN_START, loginWorker);
}

function* loginWorker(action: IAuthActions): any {
    const res: IBaseRespone<ILoginRespone> = yield call(authApi.Login, action.payload as ILoginRequest);
    if (res.is_success && res.data) {
        NotifyHelper.Success(`Chào ${res.data.user.ho_ten}!`);
        yield put(rootActions.auth.LOGIN_SUCCESS(res.data));
    } else {
        NotifyHelper.Error(res.message || "Đăng nhập thất bại.");
        yield put(rootActions.auth.LOGIN_ERROR(res.message || "Đăng nhập thất bại."));
    }
}
